import { MuiDialog } from './darkOverrides/Dialog'
import { COLORS } from './colors'
import { MuiCssBaseline } from './darkOverrides/CssBaseline'
import { createMuiTheme } from '@material-ui/core/styles'
import { MuiPickersToolbarText } from './darkOverrides/PickersToolbarText'
import { MuiIconButton } from './darkOverrides/IconButton'
import { MuiFormLabel } from './darkOverrides/MuiFormLabel'

export const darkPalette = {
  palette: {
    type: 'dark',
    primary: {
      main: COLORS.grey,
      darkest: COLORS.black
    },
    secondary: {
      main: COLORS.blue
    },
    error: {
      main: COLORS.red
    },
    background: {
      default: COLORS.grey
    },
    text: {
      primary: COLORS.white,
      secondary: COLORS.black
    }
  },
  typography: {
    fontFamily: 'PFDinDisplayPro',
    fontSize: 14,
    color: COLORS.white,
    body1: {
      fontSize: 14
    }
  },
  props: {
    MuiDialog: {
      disablePortal: true
    },
    MuiButton: {
      variant: 'outlined',
      color: 'primary'
    },
    MuiToggleButtonGroup: {
      size: 'small',
      exclusive: true
    },
    MuiToggleButton: {
      size: 'small'
    }
  }
}

export const darkTheme = createMuiTheme(darkPalette)

const { MuiButton } = require('./darkOverrides/Button')
const { MuiToggleButtonGroup } = require('./darkOverrides/ToggleButtonGroup')
const { MuiToggleButton } = require('./darkOverrides/ToggleButton')

darkTheme.overrides = {
  MuiCssBaseline,
  MuiDialog,
  MuiButton,
  MuiToggleButtonGroup,
  MuiToggleButton,
  MuiPickersToolbarText,
  MuiIconButton,
  MuiFormLabel
}
